(function ($, Cobalt, undefined) {
    var _managerModal;
    var _modalOpen = false;
    Cobalt.Dice = {
        initialize: function() {
        },
        hideModal: function() {
            if (_managerModal.length > 0) {
                _managerModal.dialog("destroy");
                _managerModal.remove();
                _modalOpen = false;
            }
        },
        showModal: function(ed) {
            if (_modalOpen) {
                return;
            }

            _modalOpen = true;

            _managerModal = $('<div id="dice-modal">');
            //build form

            _managerModal.append("<label>Count</label><input id='dice-count' type='text' placeholder='Enter in number of dice to roll' />");
            _managerModal.append("<label>Sides</label><input id='dice-size' type='text' placeholder='Enter in sides of dice (6)' />");

            _managerModal.append("<label>Modifier</label><input id='dice-modifier-check' type='checkbox' />");
            _managerModal.append("<select id='dice-modifier'><option value='+'>+</option><option value='-'>-</option></select>");
            _managerModal.append("<input id='dice-modifier-value' type='text' placeholder='Enter in a number modifier to the end of a roll' />");
            

            _managerModal.append("<span id='dice-error' style='color:red'></span>");
            _managerModal.append("<input id='dice-submit' type='submit' value='OK' />");
            
            _managerModal.dialog({
                modal: true,
                height: 300,
                width: 300,
                title: "Dice Roller",
                resizable: false,
                close: function(event, ui) {
                    _managerModal.dialog("destroy");
                    _managerModal.remove();
                    _modalOpen = false;
                }
            });
            _managerModal.parent().center();
            
            $("#dice-modifier").hide();
            $("#dice-modifier-value").hide();
            $("#dice-modal").on("change", "#dice-modifier-check", function () {
                $.log('sup');
                if ($(this).is(":checked")) {
                    $("#dice-modifier").show();
                    $("#dice-modifier-value").show();
                } else {
                    $("#dice-modifier").hide();
                    $("#dice-modifier-value").hide();
                }
            });

            var validateNumber = function isNumber(n) {
                return !isNaN(parseFloat(n)) && isFinite(n);
            };
            var errorElement = $("#dice-error");

            $("#dice-modal").on("click", "#dice-submit", function(e) {
                e.preventDefault();

                var count = $("#dice-count").val();
                if (!validateNumber(count)) {
                    errorElement.text("Count must be a number.");
                    return;
                }
                var size = $("#dice-size").val();
                if (!validateNumber(size)) {
                    errorElement.text("Size must be a number.");
                    return;
                }

                var mod = $("#dice-modifier").val();
                var modValue = $("#dice-modifier-value").val();
                
                var useMod = $("#dice-modifier-check").is(":checked") && mod && modValue;

                if (useMod) {
                    if (!validateNumber(modValue)) {
                        errorElement.text("Modifier must be a number.");
                        return;
                    }
                }
                errorElement.text("");

                var diceMarkup = "[dice={0}]{1}{2}[/dice]".format(count, size, useMod ? mod.toString() + modValue : "");
                
                if (ed && tinyMCE && tinyMCE.editors.length) {
                    ed.execCommand('mceInsertContent', false, diceMarkup);
                } else {
                    $.markItUp({ replaceWith: diceMarkup });
                }
                
                _managerModal.dialog("destroy");
                _managerModal.remove();
                _modalOpen = false;
            });

        }
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Dice.js